import './flash_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  close = (): void => {
    this.element.remove()
  }
}
